import {NotificationDataInterface} from "../interfaces/NotificationDataInterface";
import {CompleteReportResultItemInterface} from "../interfaces/CompleteReportResultItemInterface";

interface Args {
    notificationData: NotificationDataInterface
    setNotificationData: (data: NotificationDataInterface) => void
    disabled: boolean,
    environments?: CompleteReportResultItemInterface[],
    locations?: CompleteReportResultItemInterface[],
    parts?: CompleteReportResultItemInterface[],
    defects?: CompleteReportResultItemInterface[],
}

export const notificationFields = (args: Args) => {


    const {
        notificationData,
        setNotificationData,
        disabled,
        environments,
        parts,
        locations,
        defects
    } = args

    console.log('locations', locations)

    return [
        {
            label: 'Welke omgeving betreft het?',
            name: 'notificationEnvironment',
            defaultValue: 'Kies een omgeving',
            value: notificationData.environment?.Referentie,
            disabled: disabled,
            required: true,
            options: environments?.map((environment: CompleteReportResultItemInterface) => {
                return {
                    value: environment.Referentie,
                    label: environment.Naam
                }
            }),
            type: 'select',
            onChange: (data: HTMLInputElement) => {
                const environment = environments?.find((environment: CompleteReportResultItemInterface) => environment.Referentie === data.value)
                setNotificationData({...notificationData, environment: environment})
            }
        },
        {
            label: 'Welke locatie betreft het?',
            name: 'notificationLocation',
            defaultValue: 'Kies een locatie',
            value: notificationData.location?.Referentie,
            disabled: disabled,
            required: true,
            options: locations?.map((location: CompleteReportResultItemInterface) => {
                return {
                    value: location.Referentie,
                    label: location.Naam
                }
            }),
            type: 'select',
            hide: !locations.length || !notificationData.environment || !notificationData.environment['Heeft onderliggende'],
            onChange: (data: HTMLInputElement) => {
                const location = locations?.find((location: CompleteReportResultItemInterface) => location.Referentie === data.value)
                setNotificationData(
                    {...notificationData, location: location}
                )
            }
        },
        {
            label: 'Welke onderdeel betreft het?',
            name: 'notificationPart',
            defaultValue: 'Kies een onderdeel',
            value: notificationData.part?.Referentie,
            disabled: disabled,
            required: true,
            options: parts?.map((part: CompleteReportResultItemInterface) => {
                return {
                    value: part.Referentie,
                    label: part.Naam
                }
            }),
            type: 'select',
            hide: !parts.length || !notificationData.location || !notificationData.location['Heeft onderliggende'],
            onChange: (data: HTMLInputElement) => {
                const part = parts?.find((part: CompleteReportResultItemInterface) => part.Referentie === data.value)
                setNotificationData(
                    {...notificationData, part: part}
                )
            }
        },
        {
            label: 'Wat is het defect?',
            name: 'notificationPart',
            defaultValue: 'Kies een onderdeel',
            value: notificationData.defect?.Referentie,
            disabled: disabled,
            required: true,
            options: defects?.map((defect: CompleteReportResultItemInterface) => {
                return {
                    value: defect.Referentie,
                    label: defect.Naam
                }
            }),
            type: 'select',
            hide: !defects.length || !notificationData.location || !notificationData.location['Heeft onderliggende'],
            onChange: (data: HTMLInputElement) => {
                const defect = defects?.find((defect: CompleteReportResultItemInterface) => defect.Referentie === data.value)
                setNotificationData(
                    {...notificationData, defect: defect}
                )
            }
        },
        {
            label: 'Omschrijving',
            name: 'notificationDescription',
            value: notificationData.description,
            disabled: disabled,
            required: true,
            type: 'textArea',
            onChange: (data: HTMLInputElement) => setNotificationData({...notificationData, description: data.value})
        }
    ]
}